module.exports = __webpack_public_path__ + "images/icono-4-comida.jpg";